// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { deepmerge } from "@mui/utils";

import base from "./base";

const _3778 = deepmerge(base, {
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#000000",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&.PersonalDrawerIcon": {
            color: "rgba(19, 23, 32, 0.54)",
          },
          "&.AnswerAgainIcon": {
            color: "rgba(19, 23, 32, 0.54)",
          },
        },
      },
    },
  },
  palette: {
    primary: {
      light: "#658FF0",
      main: "#2662BD",
      dark: "#00398C",
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: "#FFF08C",
      main: "#F2C05C",
      dark: "#BC902C",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    error: {
      light: "#FF666D",
      main: "#C73142",
      dark: "#90001C",
      contrastText: "#FFFFFF",
    },
    warning: {
      light: "#FFAD42",
      main: "#C77E06",
      dark: "#915200",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    info: {
      light: "#48A59A",
      main: "#00766C",
      dark: "#004941",
      contrastText: "#FFFFFF",
    },
    success: {
      light: "#4CAF50",
      main: "#087F23",
      dark: "#005100",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "rgba(19, 23, 32, 0.87)",
      secondary: "rgba(19, 23, 32, 0.54)",
      disabled: "rgba(19, 23, 32, 0.38)",
      hint: "rgba(19, 23, 32, 0.38)",
    },
    grey: {
      50: "#F5F6FA",
      100: "#F1F2F5",
      200: "#E6E7EB",
      300: "#DCDDE0",
      400: "#BFC1C7",
      500: "#98999E",
      600: "#6C6E75",
      700: "#363840",
      800: "#202229",
      900: "#131720",
      A100: "#D2D3D6",
      A200: "#A4A6AB",
      A400: "#515661",
      A700: "#1D2230",
    },
    divider: "#DCDDE0",
    action: {
      active: "#F5F6FA",
      hover: "rgba(19, 23, 32, 0.08)",
      disabled: "rgba(19, 23, 32, 0.26)",
      disabledBackground: "rgba(19, 23, 32, 0.12)",
    },
  },
});

export default _3778;
